(() => {
    const imagesAttributes = document.getElementsByClassName('zoom_container');
    const popup = document.querySelector('.popup-attributes');
    const closeBtn = document.querySelector('.btn-close-attributes');
    const imageName = document.querySelector('.image-name');
    const largePreview = document.querySelector('.image-preview-attributes');
    const largeImage = document.querySelector('.large-image-attributes');
    const leftArrowMob = document.querySelector('.left-arrow-zoom-attributes');
    const rightArrowMob = document.querySelector('.right-arrow-zoom-attributes');
    const leftArrow = document.querySelector('.left-arrow-attributes');
    const rightArrow = document.querySelector('.right-arrow-attributes');
    const minusBtn = document.querySelector('.minus-zoom-attributes');
    const plusBtn = document.querySelector('.plus-zoom-attributes');
    const canvasZoom = document.querySelector('.canvasZoom');
    let bodyTemplate = document.getElementsByTagName('body');
    let index = 0;
    let scale = 1;
    let counter = 1;
    const zoom = {
        min: 1,
        max: 5,
        value: 1,
        step: 0.05
    };
    let x, y;
    let resetTimeout;
    const buttonLeft = [leftArrowMob, leftArrow];
    const buttonRight = [rightArrowMob, rightArrow];
    var window_width = null;
    widthActual();

    for (let i = 0; i < imagesAttributes.length; i++) {
        let attribute = imagesAttributes[i];
        let image = attribute.getElementsByClassName('zoom-image')[0];
        let image_src = image.getAttribute('src');

        attribute.addEventListener('click', () => {
            largeImage.src = `${image_src}`
            updateImage(i, largeImage.src);
            popup.classList.toggle('active');
            bodyTemplate[0].style.overflow = 'hidden';
        });
    }

    const updateImage = (i) => {
        let newImage = imagesAttributes[i].getElementsByTagName('img')[0].src;
        largeImage.src = `${newImage}`;
        index = i;
        resetZoom();
    }

    closeBtn.addEventListener('click', () => {
        popup.classList.toggle('active');
        bodyTemplate[0].style.overflow = '';
        resetZoom();
    });

    buttonLeft.map(btn => {
        btn.addEventListener('click', (event) => {
            activeArrows(event.target.parentElement, 0);

            if (index > 0) {
                updateImage(index - 1);
            }
        });
    });

    buttonRight.map(btn => {
        btn.addEventListener('click', (event) => {
            activeArrows(event.target.parentElement, 1);
            if (index < imagesAttributes.length - 1) {
                updateImage(index + 1);
            }
        });
    });

    minusBtn.addEventListener('click', (event) => {
        if (counter > 1) {
            counter = counter - 1;
            largeImage.style.transform = `scale(${counter})`;
        }
    });

    plusBtn.addEventListener('click', (event) => {
        if (counter <= 8) {
            counter = counter + 1;
            largeImage.style.transform = `scale(${counter})`;
            largeImage.style.transformOrigin = '50%' + ' ' + '50%';
        }
    });

    largePreview.addEventListener('wheel', (event) => {
        event.preventDefault();
        zoomWheelPointer(event);
    });

    largePreview.addEventListener('mousemove', e => {
        x = e.clientX - largePreview.offsetLeft;
        y = e.clientY - largePreview.offsetTop;
    });

    largePreview.addEventListener('mouseleave', e => {
        resetZoom();
        counter = 1;
        const zoom = {
            min: 1,
            max: 5,
            value: 1,
            step: 0.05
        };
        x, y;

        largeImage.style.transform = 'scale(1)';
        largeImage.style.transformOrigin = '0px' + ' ' + '0px';
        largeImage.style.transitionDuration = '1s';
    });

    const activeArrows = ( btn, dir ) => {
        let indexlImagesAttributes = imagesAttributes.length - 1;
        let newIndex = index + 1;

        if(dir == 1) {
            buttonLeft.map(btn => newIndex != 0 ? btn.disabled = false : btn.disabled = true );
            buttonRight.map(btn => newIndex == indexlImagesAttributes ? btn.disabled = true : btn.disabled = false );

        } else {
            buttonLeft.map(btn => index == 1 ? btn.disabled = true : btn.disabled = false );
            buttonRight.map(btn => newIndex <= imagesAttributes.length ? btn.disabled = false : btn.disabled = true );
        }
    };

    const zoomBtn = (event) => {
        scale += event.deltaY * -0.01;
        scale = Math.min(Math.max(0.125, scale), 10);
        largeImage.style.transform = `scale(${scale})`;
        var xPerc = (x * 100) / largeImage.width;
        var yPerc = (y * 100) / largeImage.height;
        largeImage.style.transformOrigin = xPerc + '%' + ' ' + yPerc + '%';
    };

    const zoomWheel = (event) => {
        scale += event.deltaY * -0.01;
        scale = Math.min(Math.max(0.125, scale), 10);
        largeImage.style.transform = `scale(${scale})`;
    };

    const zoomWheelPointer = (event) => {
        const elemento = largeImage;
        const factorZoom = 0.1;

        elemento.addEventListener('wheel', (event) => {
            event.preventDefault();

            if (event.deltaY < 0) {
                zoom.value = zoom.value >= zoom.max ? zoom.max : zoom.value + zoom.step;

            } else if (event.deltaY > 0) {
                zoom.value = zoom.value <= zoom.min ? zoom.min : zoom.value - zoom.step;
            }

            largeImage.style.transform = `scale(${zoom.value})`
            var xPerc = (x * 50) / largeImage.width;
            var yPerc = (y * 50) / largeImage.height;
            largeImage.style.transformOrigin = xPerc + '%' + ' ' + yPerc + '%';
        });
    };

    const resetZoom = () => {
        largeImage.style.transform = `scale(1)`;
        largeImage.style.transitionDuration = '1.5s';
    }

    function widthActual() {
        window_width = window.innerWidth;
    }

    document.addEventListener("DOMContentLoaded", (ev) => {
        widthActual();
        if (window_width > 1200) {
            largePreview.classList.add('v-desktop');
            largeImage.classList.add('v-desktop');
            canvasZoom.classList.add('v-desktop');
        } else {
            largePreview.classList.add('v-mobile');
            largeImage.classList.add('v-mobile');
            canvasZoom.classList.add('v-mobile');
        }
    });

    window.addEventListener("resize", (event) => {
        widthActual();
        toggleClass();
    });

    function toggleClass() {
        if (window_width > 1200 && largePreview.classList.contains('v-mobile') && largeImage.classList.contains('v-mobile') && canvasZoom.classList.contains('v-mobile')) {
            largePreview.classList.remove('v-mobile');
            largePreview.classList.add('v-desktop');
            largeImage.classList.remove('v-mobile');
            largeImage.classList.add('v-desktop');
            canvasZoom.classList.remove('v-mobile');
            canvasZoom.classList.add('v-desktop');

        } else if (window_width <= 1200 && largePreview.classList.contains('v-desktop') && largeImage.classList.contains('v-desktop') && canvasZoom.classList.contains('v-desktop')) {
            largePreview.classList.add('v-mobile');
            largePreview.classList.remove('v-desktop');
            largeImage.classList.add('v-mobile');
            largeImage.classList.remove('v-desktop');
            canvasZoom.classList.add('v-mobile');
            canvasZoom.classList.remove('v-desktop');
        }
    }

    if (window_width <= 1200) {
        var angleScale = {
            angle: 0,
            scale: 1
        };

        interact(largePreview)
            .gesturable({
                listeners: {
                    start(event) {
                        angleScale.angle -= event.angle;
                        clearTimeout(resetTimeout);
                        largeImage.classList.remove('reset');
                    },
                    move(event) {
                        var currentAngle = event.angle + angleScale.angle;
                        var currentScale = event.scale * angleScale.scale;
                        largeImage.style.transform = 'scale(' + currentScale + ')';
                        dragMoveListener(event);
                    },
                    end(event) {
                        angleScale.angle = angleScale.angle + event.angle;
                        angleScale.scale = angleScale.scale * event.scale;
                        resetTimeout = setTimeout(reset, 1000);
                    }
                }
            }).draggable({
                autoScroll: true,
                inertia: true,
                modifiers: [
                    interact.modifiers.restrictRect({
                        restriction: 'parent',
                        endOnly: true
                    })
                ],
                listeners: {
                    move: dragMoveListener
                }
            });

    }

    function dragMoveListener(event) {
        var target = event.target;
        var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
        var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
        target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
    }

    function reset() {
        largePreview.removeAttribute('data-y');
        largePreview.removeAttribute('style');
        largeImage.style.transform = 'scale(1)';
        largeImage.style.transitionDuration = '1.5s';

        angleScale = {
            angle: 0,
            scale: 1
        }
    }

    function dragMoveListener(event) {
        var target = event.target;
        var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
        var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
        target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        target.setAttribute('data-x', x)
        target.setAttribute('data-y', y)
    }
})()